import React, { useState, useEffect } from 'react';
import { Paginator } from 'primereact/paginator';

const DepartmentListing = ({ data, onEdit, onDelete, isLoading, canManage }) => {
    const [first, setFirst] = useState(0);
    const [isDesktop, setIsDesktop] = useState(true);
    const rows = 20;

    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth > 992);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setFirst(0);
    }, [data]);

    const paginatedData = data.slice(first, first + rows);

    const onPageChange = (event) => {
        setFirst(event.first);
    };

    return (
        <div className="table-card" style={{ overflowX: 'auto', background: '#fff', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', paddingBottom: '10px' }}>
            {isLoading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <i className="fa-solid fa-circle-notch fa-spin fa-2x" style={{ color: '#3498db', marginRight: '10px' }}></i>
                    <p style={{ marginTop: '10px', color: '#666' }}>Đang tải dữ liệu</p>
                </div>
            ) : data.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '60px 20px', color: '#666' }}>
                    <i className="fa-solid fa-sitemap" style={{ fontSize: '60px', color: '#5dade2', marginBottom: '15px' }}></i>
                    <h3 style={{ color: '#e74c3c', margin: '0 0 10px 0' }}>Không tìm thấy đơn vị nào</h3>
                </div>
            ) : (
                <>
                    <table className="custom-table" style={{ minWidth: isDesktop ? '1200px' : '100%' }}>
                        <thead>
                            <tr>
                                <th width="5%" style={{ textAlign: 'center' }}>STT</th>
                                <th width="25%">ĐƠN VỊ</th>
                                <th width="25%">ĐƠN VỊ CẤP TRÊN</th>
                                <th width="15%">NGƯỜI QUẢN LÝ</th>
                                <th width="15%">ĐIỆN THOẠI</th>
                                <th width="10%" style={{ textAlign: 'center' }}>TỔNG SỐ USER</th>
                                {canManage && <th width="5%" style={{ textAlign: 'center' }}>CHỨC NĂNG</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedData.map((item, index) => {
                                const actualIndex = first + index + 1;

                                return (
                                    <tr key={item.Id}>
                                        <td style={{ textAlign: 'center' }}>{actualIndex}</td>
                                        <td style={{ fontWeight: '500', color: '#0056b3' }}>{item.Name}</td>
                                        <td>{item.ParentName || '---'}</td>
                                        <td>{item.Manager || '---'}</td>
                                        <td>{item.ContactInfo || '---'}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            <span style={{ fontWeight: 'bold', color: item.TotalUsers > 0 ? '#28a745' : '#999' }}>
                                                {item.TotalUsers}
                                            </span>
                                        </td>
                                        {canManage && (
                                            <td>
                                                <div className="action-group" style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                                                    <div className="icon-wrapper edit-wrapper" onClick={() => onEdit(item)} style={{ cursor: 'pointer' }}>
                                                        <i className="fa-solid fa-pen edit-icon" style={{ color: '#3498db' }}></i>
                                                    </div>
                                                    <div className="icon-wrapper delete-wrapper" onClick={() => onDelete(item.Id)} style={{ cursor: 'pointer' }}>
                                                        <i className="fa-solid fa-trash delete-icon" style={{ color: '#e74c3c' }}></i>
                                                    </div>
                                                </div>
                                            </td>
                                        )}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    {data.length > rows && (
                        <div style={{ marginTop: '15px', borderTop: '1px solid #e9ecef', paddingTop: '10px' }}>
                            <Paginator
                                first={first}
                                rows={rows}
                                totalRecords={data.length}
                                onPageChange={onPageChange}
                                template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                                currentPageReportTemplate="Đang hiển thị {first} đến {last} trong tổng số {totalRecords} đơn vị"
                                style={{ background: 'transparent', border: 'none' }}
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default DepartmentListing;